import React from "react";
// import './Tarh.css';
import { useContext, useState, useRef } from "react";
import SimpleContext from "./../context/SimpleContext";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import DiscountBtn from "../Buttons/DiscountBtn";
import NumberFormat from "react-number-format";
import accept from "../img/accept.png";
import right from "../img/right.png";
import { useHistory } from "react-router";
import { useEffect } from "react";
import Preloader from "../Preloader/preloader";

const TarhDetails = () => {
  const context = useContext(SimpleContext);
  const [open, setOpen] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [img, setimg] = useState([]);
  const history = useHistory();

  const sheetRef = React.useRef();
  //برای هندل کردن ارور عکس ها
  const addDefaultSrc = (ev) => {
    ev.target.src = "/images/placeholder.jpg";
  };
  //تابع برای نمایش مودال که عکس هارا نشان میدهد
  const ModalImage = (img) => {
    setshowModal(true);
    setimg(img);
  };

  //رفتن به صفحه جزییات محصول با شناسه کاربر
  const ShowProductInfo = (product) => {
    if(parseInt(product.stock) === 0||parseInt(product.stock) < 0){
      context.Handelerror(product.stockToast)
    }else{
      history.push(`/product/${product.productRef}`);
      context.setproductRoight(product.productRef);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          height: "60px",
          // position: "fixed",
          zIndex: "3",
          top: "0",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            width: "15%",
            display: "flex",
            justifyContent: "flex-start",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <img
            onClick={() => history.go(-1)}
            className="backIcon"
            src={right}
          />
        </div>
        <div
          style={{
            width: "70%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              margin: "0",
              fontWeight: "bold",
              fontSize: "14px",
              display: "flex",
              textAlign: "center",
              alignItems: "center",
              padding: "5px",
            }}
          >
            {context.TarhaTitle}
          </p>
        </div>
        <div style={{ width: "15%", visibility: "hidden" }}>
          <p>hiiii</p>
        </div>
      </div>

      <div className="Tarh-main">
        <div
          style={{
            width: "100%",
            display: "flex",
            backgroundColor: "#e5e5e5",
            height: "100vh",
            justifyContent: "center",
          }}
        >
          <div style={{ position: "relative" }} className="Tarh-main-details">
            {context.discountStep.length > 0 &&
              context.discountStep.map((i) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    gap: "15px",
                    position: "relative",
                  }}
                >
                  {context.discountStep.length > 1 ? (
                    context.discountStep.indexOf(i) === 0 ? (
                      <div
                        style={{
                          height: "100%",
                          backgroundColor: "rgb(255 167 111)",
                          width: "20px",
                          position: "absolute",
                          right: "35px",
                          marginTop: "60px",
                          zIndex: "1",
                        }}
                      >
                        <p
                          style={{
                            color: "rgb(255 167 111)",
                            visibility: "hidden",
                          }}
                        >
                          {i.discountPercent}
                        </p>
                      </div>
                    ) : (
                      context.discountStep.indexOf(i) ===
                        context.discountStep.length - 1 && (
                        <div
                          style={{
                            height: "100%",
                            backgroundColor: "rgb(255 167 111)",
                            width: "20px",
                            position: "absolute",
                            right: "35px",
                            marginBottom: "80px",
                            zIndex: "1",
                          }}
                        >
                          <p
                            style={{
                              color: "rgb(255 167 111)",
                              visibility: "hidden",
                            }}
                          >
                            {i.discountPercent}
                          </p>
                        </div>
                      )
                    )
                  ) : null}

                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      alignItems: "center",
                      zIndex: "2",
                    }}
                  >
                    <p
                      style={{
                        position: "absolute",
                        color: "#fff",
                        margin: "0",
                        fontSize: "14px",
                      }}
                    >
                      {i.discountPercent}
                    </p>
                    <img style={{ width: "90px" }} src={i.imageLink} />
                  </div>

                  {i.discountPercent === "0" ? (
                    <div
                      className={
                        i.isAchieved === true ? "isAchieved" : "notisAchieved"
                      }
                    >
                      <div
                        style={{
                          borderBottom: "1px solid #e5e5e5",
                          position: "relative",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "gray",
                            fontSize: "14px",
                            margin: "0",
                            padding: "10px",
                          }}
                        >
                          {i.bonusDescription}
                        </p>
                        {i.isAchieved === true && (
                          <img
                            style={{
                              position: "absolute",
                              width: "25px",
                              left: "5px",
                              bottom: "0",
                            }}
                            src={accept}
                          />
                        )}
                      </div>

                      <div style={{ padding: "15px" }}>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "gray",
                            fontSize: "14px",
                            margin: "0",
                          }}
                        >
                          {i.discountStepTitle}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        height: "10vh",
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                      }}
                      className={
                        i.isAchieved === true ? "isAchieved" : "notisAchieved"
                      }
                    >
                      <div style={{ padding: "15px", position: "relative" }}>
                        {i.isAchieved === true && (
                          <img
                            style={{
                              position: "absolute",
                              width: "25px",
                              left: "0",
                              bottom: "-10px",
                            }}
                            src={accept}
                          />
                        )}
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "gray",
                            fontSize: "14px",
                            margin: "0",
                          }}
                        >
                          {i.discountStepTitle}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="App">
        {/* <button onClick={() => setOpen(!open)}>{open ? "close" : "open"}</button> */}
        <BottomSheet
          ref={sheetRef}
          open={true}
          snapPoints={({ minHeight, maxHeight }) => [
            0.2 * minHeight,
            1 * maxHeight,
          ]}
          defaultSnap={({ lastSnap, snapPoints }) => {
            lastSnap ?? Math.max(...snapPoints);
          }}
          // initialSnapIndex={0}
          blocking={false}
          header={
            <div style={{ fontWeight: "bold" }} className="sheetHeader">
              کالاهای طرح
            </div>
          }
          // snapPoints={({ maxHeight }) => 1 * maxHeight}
        >
          <div
            style={{ marginTop: "0" }}
            className={
              context.showPre === false
                ? "categoriesdiv"
                : "categoriesdivWidthPage"
            }
          >
            {
            context.searchProducts!==null&&context.searchProducts!==undefined&&
            Object.values(context.searchProducts).length > 0
              ? context.searchProducts.productLists.map((i) => (
                  <>
                    <div key={i.productCode} className="category">
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "100%%",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          textAlign: "center",
                          flexDirection: "row",
                          gap: "4.5px",
                        }}
                      >
                        <div
                          
                          style={{
                            width: "40%",
                 
                          }}
                        >
                          <img
                            className={
                              parseInt(i.stock) === 0||parseInt(i.stock)<0 ? "namojud" : "mojud"
                            }
                            onClick={() => ModalImage(i.imageUrl)}
                            onError={addDefaultSrc}
                            style={{ width: "100%", height: "100%" }}
                            src={i.imageUrl}
                          />
                        </div>

                        <div
                          
                          className="mainRowCat"
                          style={{ width: "60%", gap: "5px" }}
                        >
                          <div  className="itemProduct">
                            <p
                            onClick={()=>ShowProductInfo(i)}
                              style={{
                                color: "gray",
                                fontWeight: "bold",
                                margin: "0",
                              }}
                            >
                              {i.brandName}
                            </p>
                          </div>

                          <div onClick={()=>ShowProductInfo(i)} className="itemProduct">
                            <p
                              style={{
                                display: "flex",
                                textAlign: "right",
                                fontWeight: "bold",
                                margin: "0",
                                fontSize: "14px",
                              }}
                            >
                              {i.productName}
                            </p>
                          </div>

                          <div
                          onClick={()=>ShowProductInfo(i)}
                            style={{ justifyContent: "space-between" }}
                            className="itemProduct"
                          >
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "gray",
                                margin: "0",
                              }}
                            >
                              قیمت مصرف کننده
                            </p>

                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "gray",
                                margin: "0",
                              }}
                            >
                              قیمت پایه
                            </p>
                          </div>

                          <div
                          onClick={()=>ShowProductInfo(i)}
                            style={{ justifyContent: "space-between" }}
                            className="itemProduct"
                          >
                            <p style={{ fontWeight: "bold", margin: "0" }}>
                              {" "}
                              <NumberFormat
                                value={i.userPrice}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                                  {" "}
                                      ریال
                            </p>

                            <p style={{ fontWeight: "bold", margin: "0" }}>
                              <NumberFormat
                                value={i.price}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                                  {" "}
                                      ریال
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                    
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          gap: "15px",
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            height: "40px",
                          }}
                          onClick={()=>ShowProductInfo(i)}
                        >
                          {i.hasDiscountOffer !== "" ? (
                            <button
                              className="ButtonBtnDis"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "50px",
                                border: "1px solid #ff7014",
                                backgroundColor: "#ff7014",
                                color: "#fff",
                                fontWeight: "lighter",
                              }}
                            >
                              {i.hasDiscountOffer}
                            </button>
                          ) : null}
                        </div>

                        <div
                       
                          style={{
                            width: "30%",
                            height: "35px",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                          className="itemProductRow"
                        >
                          {i.basketSelection === "0" || i.basketSelection === 0
                            ? `${i.unitName}`
                            : `${i.basketSelection}${i.unitName}`}
                        </div>

                        <div
                          style={{
                            width: "30%",
                            height: "35px",
                            justifyContent: "flex-end",
                          }}
                          className="itemProductRow"
                        >
                          <DiscountBtn Product={i} />
                        </div>
                      </div>
                    </div>
                  </>
                ))
              : <Preloader/>}
          </div>
        </BottomSheet>
      </div>
    </div>
  );
};

export default TarhDetails;
